import { getWhiteLabelConfig } from "./getWhiteLabelConfig";

/**
 * Product name shown in user-facing copy: the tenant's company in white-label
 * mode, "Alli AI" otherwise. Never hardcode "Alli AI" in UI text.
 */
export function getBrandName(): string {
  return getWhiteLabelConfig().company_name;
}
